jQuery(document).ready(function($){

  /*
  

  $('.aside_map select').change(function() {
    // $(this) refers directly to the active select element
    var value = $(this).val(); 
    var text = $(this).find('option:selected').text(); 
    $("#actl_flter").html(value);
    if(value == "Colombia"){
      $(".genrlmap").not("mapcol").fadeOut();
      $(".mapcol").fadeIn();
    }else if(value == "Canada"){
      $(".genrlmap").not("mapcan").fadeOut();
      $(".mapcan").fadeIn();
    }else if(value == "Todo"){
      $(".genrlmap").fadeIn();
    }else if(value == "All"){
      $(".genrlmap").fadeIn();
    }
    
    console.log("Value:", value, "Text:", text);
  });
  */

  $(".aside_map ul li").click(function(){
    $(this).addClass("actvmap");
    $(".aside_map ul li").not(this).removeClass("actvmap");

    window.mapchng = $(this).data("lnkmap");
    $(".blkstrt_map iframe").attr("src",mapchng);
  });

  $('.aside_map select').change(function() {
    var value = $(this).val();
    $("#actl_flter").html(value);

    if (value === "Todo" || value === "All") {
      $(".genrlmap").fadeIn();
    } else {
      var slug = value.toLowerCase().replace(/\s/g, '');
      $(".genrlmap").not(".map" + slug).fadeOut();
      $(".map" + slug).fadeIn();
    }
  });

  setTimeout(function() {
    $(".hedr-pia").addClass("chncllbnnr");
  }, 500);

  $("ul.lstng-espcfaq li").eq(0).click(function(){
    $("body, html").animate({scrollTop:$("section#shopify-section-template--22208857047314__collapsible_content_7CVkd4").offset().top-80},800)
  }); 
  $("ul.lstng-espcfaq li").eq(1).click(function(){
    $("body, html").animate({scrollTop:$("section#shopify-section-template--22208857047314__collapsible_content_GdwpCt").offset().top-80},800)
  }); 
  $("ul.lstng-espcfaq li").eq(2).click(function(){
    $("body, html").animate({scrollTop:$("section#shopify-section-template--22208857047314__collapsible_content_HMEcpe").offset().top-80},800)
  }); 
  $("ul.lstng-espcfaq li").eq(3).click(function(){
    $("body, html").animate({scrollTop:$("section#shopify-section-template--22208857047314__collapsible_content_xmdreG").offset().top-80},800)
  }); 
  $("ul.lstng-espcfaq li").eq(4).click(function(){
    $("body, html").animate({scrollTop:$("section#shopify-section-template--22208857047314__collapsible_content_9UCCdi").offset().top-80},800)
  }); 
  
  $(".rdmorelnk").click(function(){
    $(this).fadeOut();
    $(".dshed-hdn").fadeOut();
    $(this).parent().find("p").slideDown();
  });
  
  $(".popjoinbrth").click(function(){
    $(".cntpop-join").fadeIn();
  });
  $(".cls-popjoin").click(function(){
    $(".cntpop-join").fadeOut();
  });

  $(".loadopop-video").click(function(){
    window.geturl = $(this).data("ifrm");
    $(".drctlnk-frms").attr("src",geturl);
    $(".cntpop-frms").fadeIn();
  });
  
  $(".cls-popfrms").click(function(){
    $(".cntpop-frms").fadeOut();
    $(".drctlnk-frms").attr("src","");
  });
  
  if (localStorage.getItem('selctry') === null) {
      localStorage.setItem('selctry', 0);
      $(".pop-init").fadeIn();
  }

  $("#fttchngiodm").change(function(){
    let getftrlang = $(this).val();
    if(getftrlang == 'English' || getftrlang == 'Ingles'){
      localStorage.setItem('lang', 'ENG');
      location.href = "/";
    }else{
      localStorage.setItem('lang', 'ESP');
      location.href = "/es";
    }
  });
  
  $(".get-translt").change(function(){
    let getlang = $(this).val();
    if(getlang == 'English'){
      localStorage.setItem('lang', 'ENG');
      $("#rturnto").val("/");
    }else{
      localStorage.setItem('lang', 'ESP');
      $("#rturnto").val("/es");
    }
  });
  /* change text */
  const carouselText = [
    {text: "a vape", color: "white"},
    {text: "an e-cigarette", color: "white"},
    {text: "a tobacco pipe", color: "white"},
    {text: "a vapour diffuser", color: "white"},
    {text: "a smoking device", color: "white"},
    {text: "battery powered", color: "white"},
    {text: "a cannabis pipe", color: "white"},
    {text: "a combusting device", color: "white"}
  ]

  const carouselText2 = [
    {text: "un vape", color: "white"},
    {text: "un cigarrillo electrónico", color: "white"},
    {text: "una pipa de tabaco", color: "white"},
    {text: "un difusor de vapor", color: "white"},
    {text: "un aparato para fumar", color: "white"},
    {text: "un aparato de baterías", color: "white"},
    {text: "una pipa de cannabis", color: "white"},
    {text: "un aparato de combustión", color: "white"}
  ]
  
  $( document ).ready(async function() {
    carousel(carouselText, "#feature-text");
    carousel(carouselText2, "#feature-text2");
  });

  
  async function typeSentence(sentence, eleRef, delay = 100) {
    const letters = sentence.split("");
    let i = 0;
    while(i < letters.length) {
      await waitForMs(delay);
      $(eleRef).append(letters[i]);
      i++
    }
    return;
  }
  
  async function deleteSentence(eleRef) {
    const sentence = $(eleRef).html();
    const letters = sentence.split("");
    let i = 0;
    while(letters.length > 0) {
      await waitForMs(100);
      letters.pop();
      $(eleRef).html(letters.join(""));
    }
  }

  async function carousel(carouselList, eleRef) {
      var i = 0;
      while(true) {
        updateFontColor(eleRef, carouselList[i].color)
        await typeSentence(carouselList[i].text, eleRef);
        await waitForMs(1500);
        await deleteSentence(eleRef);
        await waitForMs(500);
        i++
        if(i >= carouselList.length) {i = 0;}
      }
  }
  
  function updateFontColor(eleRef, color) {
    $(eleRef).css('color', color);
  }
  
  function waitForMs(ms) {
    return new Promise(resolve => setTimeout(resolve, ms))
  }
  /**/
  
  $(".eng-atvrdpop1").click(function(){
    $(".iccn-flwrback").attr("src","//957291-5.myshopify.com/cdn/shop/t/1/assets/iccn-popact1.svg");
    $(".popup-flwer h2").html("Sustainable");
    $(".popup-flwer p").html("Each PIA is made by hand with local Organic Bamboo and designed with a re-usable cotton wick system that requires No Battery, No Water, No Combustion, No Heat, and produces No Smoke, and No Waste.");
    $(".popup-flwer").fadeIn();
  });
  $(".eng-atvrdpop2").click(function(){
    $(".iccn-flwrback").attr("src","//957291-5.myshopify.com/cdn/shop/t/1/assets/iccn-popact22.svg");
    $(".popup-flwer h2").html("Therapeutic");
    $(".popup-flwer p").html("Benefit from slow conscious breathing of aromas that promote relaxation and calm. PIA is also an excellent option for aromatherapy practitioners and people who want to quit smoking or vaping. Using just one drop of your favorite 100% Pure Essential Oil (includes a 2 ml bottle) can help reduce anxiety, fill you with energy, and produce a sense of fulfillment and joy.");
    $(".popup-flwer").fadeIn();
  });
  $(".eng-atvrdpop3").click(function(){
    $(".iccn-flwrback").attr("src","//957291-5.myshopify.com/cdn/shop/t/1/assets/iccn-popact33.svg");
    $(".popup-flwer h2").html("Personal");
    $(".popup-flwer p").html("Each PIA reflects the uniqueness of the life of each bamboo that is used to make it. As a Personal Diffuser PIA lets you enjoy your favourite Essential Oils everywhere -even on a plane- and keep the experience to yourself.");
    $(".popup-flwer").fadeIn();
  });
  $(".eng-atvrdpop4").click(function(){
    $(".iccn-flwrback").attr("src","//957291-5.myshopify.com/cdn/shop/t/1/assets/iccn-popact4.svg");
    $(".popup-flwer h2").html("Handmade");
    $(".popup-flwer p").html("PIA is made by caring hands in the mountains of Colombia where local organic bamboo is masterfully transformed into a treasured artifact for well being.");
    $(".popup-flwer").fadeIn();
  });
  $(".eng-atvrdpop5").click(function(){
    $(".iccn-flwrback").attr("src","//957291-5.myshopify.com/cdn/shop/files/iccn-popact5.svg");
    $(".popup-flwer h2").html("Aromas");
    $(".popup-flwer p").html("Essential Oils are not exactly oils, they are concentrated Volatile Organic Compounds extracted from plants that float on water and easily evaporate at normal temperatures. Use only 100% Essential Oils and apply to the cotton wick of your PIA.");
    $(".popup-flwer").fadeIn();
  });
  $(".eng-atvrdpop6").click(function(){
    $(".iccn-flwrback").attr("src","//957291-5.myshopify.com/cdn/shop/files/iccn-popact6.svg");
    $(".popup-flwer h2").html("Portable");
    $(".popup-flwer p").html("Its design and materials make it small and light, yet strong, discreet, and easy to carry with you everywhere you go. Each PIA weighs less than 5 g, measures less than 8.5 cm in length, and 1.5 cm in diameter.");
    $(".popup-flwer").fadeIn();
  });

  //

  $(".esp-atvrdpop1").click(function(){
    $(".iccn-flwrback").attr("src","//957291-5.myshopify.com/cdn/shop/t/1/assets/iccn-popact1.svg");
    $(".popup-flwer h2").html("Sostenible");
    $(".popup-flwer p").html("Cada PIA está hecho a mano con bambú orgánico local y diseñado con un sistema de mecha de algodón reutilizable que no requiere batería, agua, combustión, calor y no produce humo ni residuos.");
    $(".popup-flwer").fadeIn();
  });
  $(".esp-atvrdpop2").click(function(){
    $(".iccn-flwrback").attr("src","//957291-5.myshopify.com/cdn/shop/t/1/assets/iccn-popact22.svg");
    $(".popup-flwer h2").html("Terapéutico");
    $(".popup-flwer p").html("Benefíciate de la respiración lenta y consciente de aromas que fomentan la relajación y la calma. PIA también es una excelente opción para los practicantes de la aromaterapia y las personas que desean dejar de fumar o vapear. Usar solo una gota de tu Aceite Esencial 100% Puro favorito (incluye una botella de 2 ml) puede ayudar a reducir la ansiedad, llenarte de energía y producir una sensación de plenitud y alegría.");
    $(".popup-flwer").fadeIn();
  });
  $(".esp-atvrdpop3").click(function(){
    $(".iccn-flwrback").attr("src","//957291-5.myshopify.com/cdn/shop/t/1/assets/iccn-popact33.svg");
    $(".popup-flwer h2").html("Personal");
    $(".popup-flwer p").html("Cada PIA refleja la singularidad de la vida de cada bambú que se utiliza para fabricarlo. Como Difusor Personal, PIA te permite disfrutar de tus Aceites Esenciales favoritos en cualquier lugar, incluso en un avión, y mantener la experiencia para ti.");
    $(".popup-flwer").fadeIn();
  });
  $(".esp-atvrdpop4").click(function(){
    $(".iccn-flwrback").attr("src","//957291-5.myshopify.com/cdn/shop/t/1/assets/iccn-popact4.svg");
    $(".popup-flwer h2").html("Hecho a mano");
    $(".popup-flwer p").html("PIA es hecho por cuidadosas manos en las montañas de Colombia, donde el bambú orgánico local es transformado con delicadeza en un elemento valioso para el bienestar.");
    $(".popup-flwer").fadeIn();
  });
  $(".esp-atvrdpop5").click(function(){
    $(".iccn-flwrback").attr("src","//957291-5.myshopify.com/cdn/shop/files/iccn-popact5.svg");
    $(".popup-flwer h2").html("Aroma");
    $(".popup-flwer p").html("Los Aceites Esenciales no son exactamente aceites, son Compuestos Orgánicos Volátiles concentrados, extraídos de plantas, que flotan en el agua y se evaporan fácilmente a temperaturas normales. Usa solo Aceites Esenciales 100% puros y aplica en la mecha de algodón de tu PIA.");
    $(".popup-flwer").fadeIn();
  });
  $(".esp-atvrdpop6").click(function(){
    $(".iccn-flwrback").attr("src","//957291-5.myshopify.com/cdn/shop/files/iccn-popact6.svg");
    $(".popup-flwer h2").html("Portátil");
    $(".popup-flwer p").html("Su diseño y materiales lo hacen pequeño y ligero, pero fuerte, discreto y fácil de llevar contigo a todas partes. Cada PIA pesa menos de 5 g, mide menos de 8.5 cm de longitud y 1.5 cm de diámetro.");
    $(".popup-flwer").fadeIn();
  });

  $(".cls-flwers").click(function(){
    $(".popup-flwer").fadeOut();
  });
  
  
  $("#inifrm").submit(function(e) {
    e.preventDefault();
    $(".pop-init").fadeOut();
  });
});





